export default __webpack_public_path__ + "static/image09-148dda2aba29de6e778f2db4c84328a1.webp";